export const environment = {
    apiUrl: 'https://watesistema.com.br/api/v1',
    zipcodeAPIUrl: 'https://viacep.com.br/ws/',
    theme: 'lg',
    title: 'Assistência Técnica LG',
    changeContactByGeolocation: false,
    showAllWhatsAppNumbers: true,
    fantasy_name: 'LavTec Assistência Técnica',
    google: {
        tagmanager: {
            key: 'GTM-W923CMKW'
        }
    },
    idCompany: '4',
    content: {
        region: {
            zipcode: '82840-220',
            name: 'Curitiba'
        },
        brand: 'LG',
        product: 'Lava e Seca',
        term: 'Assistência Técnica'
    },

    contacts: {
        whatsapp: [
            {
                name: 'Central de Atendimento',
                number: '554123912324',
                text: '(41) 2391-2324',
                message: 'Olá, gostaria de saber mais sobre os serviços de assistência técnica.'
            },
            // {
            //     name: 'Central de Atendimento',
            //     number: '5541984212324',               
            //     text: '(41) 98421-2324',
            //     message: 'Olá, gostaria de saber mais sobre os serviços de assistência técnica.'
            // }
        ],
        phone: [
            {
                number: '+554123912324',
                text: '(41) 2391-2324'
            },
        ]
    }
};
